export default "__VITE_ASSET__0_OIQhcR__";